import React, { useContext, useState } from 'react';
import { Button, Modal, Toast } from '../../uiComponents/common';
import { WelletContext } from '../../context/wellet/welletContext';
import { useMutation } from 'react-query';
import { postSettleRefund } from '../../services';
import { useTranslation } from 'react-i18next';
import { Show } from '../../components';

const ModalSettleRefund = ({ onClose, handleSubmit, reservation }) => {
  const welletContext = useContext(WelletContext);
  const { t } = useTranslation('translation', { keyPrefix: 'modals.modalSettleRefund' });
  const [openRefund, setOpenRefund] = useState('');

  // API Querys
  const refundMutation = useMutation({
    mutationFn: () => {
      return postSettleRefund(welletContext, reservation?.id);
    },
  });

  // Functions
  const handleModal = () => {
    setOpenRefund((prevState) => !prevState);
  };
  const handleClose = () => {
    refundMutation.reset();
    onClose();
    handleModal();
  };
  const onSubmit = () => {
    return refundMutation.mutate();
  };

  return (
    <>
      {/* Toasts */}
      <Show.When isTrue={refundMutation.isSuccess}>
        <Toast message={t('toast.success')} type={`SUCCESS`} onCallback={handleClose} />
      </Show.When>
      <Show.When isTrue={refundMutation.isError}>
        <Toast message={t('toast.error')} type={`ERROR`} onCallback={handleClose} />
      </Show.When>
      <Button
        className={'btn-wellet-secondary bg-custom-light text-truncate btn-accept'}
        onClick={handleModal}
        size={'custom'}
        text={
          <>
            <span className='dot dot-green mr-2 d-inline-block'></span>
            {t('btnRefund')}
          </>
        }
      />
      <Show.When isTrue={openRefund}>
        <Modal
          title={t('title')}
          open={openRefund}
          onClose={handleModal}
          maxWidth='450px'
          closeIcon={true}
          handleSubmit={handleSubmit}
          closeOnDocumentClick={false}
          customButtons={
            <>
              <div className='row px-2 text-center'>
                <Button
                  text={t('btnClose')}
                  disabled={!refundMutation.isIdle}
                  className={'col btn-general btn-wellet-secondary'}
                  size={'medium'}
                  onClick={handleModal}
                />
                <Button
                  text={t('btnSettle')}
                  disabled={!refundMutation.isIdle}
                  className={'col ml-2 btn-general btn-wellet-primary'}
                  size={'medium'}
                  onClick={() => onSubmit()}
                />
              </div>
            </>
          }
        >
          <div className='text-left mt-2 mb-3'>{t('ask')}</div>
        </Modal>
      </Show.When>
    </>
  );
};

export default ModalSettleRefund;
